import { type ReactElement, useEffect } from "react";
import { useRouter } from "next/router";
import { useIntercom } from "react-use-intercom";

interface IProps {
  children: ReactElement;
}

/**
 * This middleware controls Intercom visibility and behavior.
 * - Hides the launcher on /work paths (old help articles not relevant)
 * - Opens the messenger on first arrival if ?contact-oliva param is present
 */
export default function IntercomMiddleware({ children }: IProps): ReactElement {
  const { show, hide, update } = useIntercom();
  const { query, pathname } = useRouter();

  const isWorkPath = pathname.startsWith("/work");

  // Hide Intercom launcher on /work paths
  useEffect(() => {
    update({ hideDefaultLauncher: isWorkPath });
    if (isWorkPath) {
      hide();
    }
  }, [isWorkPath, update, hide]);

  // We voluntarily don't add "query" in useEffect props dependencies
  // because we want Intercom to be shown only on 1st arrival
  useEffect(() => {
    if (typeof query?.["contact-oliva"] !== "undefined") {
      show();
    }
  }, []);

  return children;
}
